<template>
    <div class="give-wrap">
        <!--  门店票列表选择弹框 -->
        <a-modal
            :title='title[menuDailogType]'
            :width="980"
            :visible="visible"
            @cancel="closeModal"
            @ok="handleCreate"
            >
            <div>
                <div class="mb16 text-fail">当前门店：{{menuDailogShops.name}}</div>
                <a-form :form="form" layout="inline" v-if="menuDailogType == 'add' || menuDailogType == 'delete'">
                    <a-form-item label="商品名称">
                        <a-input style="width: 216px" placeholder="请输入" v-decorator="['name']"></a-input>
                    </a-form-item>
                    <a-form-item label="商品分类">
                        <a-input style="width: 216px" placeholder="请输入" v-decorator="['cateName']"></a-input>
                    </a-form-item>
                    <a-form-item label="上架状态">
                        <a-select style="width: 216px" allowClear placeholder="请选择" v-decorator="['state']">
                            <a-select-option value="0">上架中</a-select-option>
                            <a-select-option value="1">已下架</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="商品售价" class="mt16">
                        <a-input-group >
                            <a-input style="width: 88px;border-right: none;" placeholder="最小金额" v-decorator="['small']" />
                            <a-input style="width: 40px; border-left: none; border-right: none; pointer-events: none; backgroundColor: #fff" placeholder="~" disabled />
                            <a-input style="width: 88px; border-left: none;" placeholder="最大金额" v-decorator="['greater']" />
                        </a-input-group>
                    </a-form-item>
                    <a-form-item class="mt16" v-if="menuDailogType == 'add'">
                        <a-button @click="search" type="primary">筛选</a-button>
                        <a-button @click="handleReset">重置</a-button>
                    </a-form-item>
                    <a-form-item class="mt16" v-if="menuDailogType == 'delete'">
                        <a-button @click="deleteSearch" type="primary">筛选</a-button>
                        <a-button @click="deleteReset">重置</a-button>
                    </a-form-item>
                </a-form>
                <a-table 
                    style="word-break:break-all;" 
                    class="mt16" 
                    :scroll="{ y: 280 }" 
                    bordered :columns="columns" 
                    :dataSource="dataSource" 
                    :pagination="false" 
                    :loading="mealLoading"
                    :rowSelection="menuDailogType == 'check' ? null : {onChange: onSelectChange, selectedRowKeys: tableSelectedRowKeys}" :rowKey="record => record.dishId" 
                    >
                    <span slot="state" slot-scope="a">{{['上架中', '已下架',][Number(a)]}}</span>
                </a-table>
            </div>
        </a-modal>
        <a-modal
            title="确认删除商品"
            :visible="visibleDeleteConfirm"
            @cancel="visibleDeleteConfirm = false"
            @ok="deleteMealLists"
            >
            <span>确认删除商品吗？</span>
        </a-modal>
    </div>
</template>

<script>

    /**
     * 门店票列表选择弹框组件
     * 
     * @prop {Boolean} visible 控制弹窗是否显示
     *
     * @func closeModal 通知父组件关闭弹窗
     *
     */
    const columns = [
        {
            title: "商品分类",
            dataIndex: "dishCateName",
            scopedSlots: { customRender: "index" }
        },
        {
            title: "商品名称",
            dataIndex: "dishName",
        },
        {
            title: "上架状态",
            dataIndex: "state",
            scopedSlots: { customRender: "state" },
        },
        {
            title: "商品售价(元)",
            dataIndex: "price",
        },
    ];
    export default {
        name: "menu-list",
        zh: "添加商品",
        data() {
            return {
                visible: false,
                visibleDeleteConfirm: false,
                form: this.$form.createForm(this),
                columns,
                dataSource: [],
                tableSelectedRowKeys: [],
                selectedRows: [],
                title: {
                    "check": "查看商品",
                    "add": "添加商品",
                    "delete": "删除商品",
                },
                mealLoading: false,
                menuDailogShops: {},
                selectedMeals: {},
            };
        },
        props: {
            menuDailogType: {type: String},
        },
        watch: {},
        methods: {
            handleReset() {
                this.form.resetFields();
                this.search();
            },
            deleteMealLists() {
                for (const key in this.selectedMeals) {
                    if (this.tableSelectedRowKeys.find( el => el == key)) {
                        this.selectedRows.push(this.selectedMeals[key])
                    }
                }
                this.$emit('deleteMealList', this.selectedRows);
                this.visibleDeleteConfirm = false;
                this.visible = false;
                setTimeout(() => {
                    this.resetTable();
                }, 300);
            },
            handleCreate() {
                if (this.menuDailogType != "check" && !this.tableSelectedRowKeys.length) {
                    this.$message.error("请先选择商品");
                    return;
                }
                if (this.menuDailogType == 'add') {
                    for (const key in this.selectedMeals) {
                        if (this.tableSelectedRowKeys.find( el => el == key)) {
                            this.selectedRows.push(this.selectedMeals[key])
                        }
                    }
                    this.$emit('addMealList', this.selectedRows);
                } else if (this.menuDailogType == 'delete') {
                    this.visibleDeleteConfirm  = true;
                    return
                }
                this.visible = false;
                setTimeout(() => {
                    this.resetTable();
                }, 300);
            },
            onSelectChange(selectedRowKeys, dateString) {
                this.tableSelectedRowKeys = selectedRowKeys;
                dateString.forEach(el => {
                    this.selectedMeals[el.dishId] = el;
                });
            }, 
            closeModal() {
                this.visible = false;
            },
            resetTable() {
                this.tableSelectedRowKeys = [];
                this.dataSource = [];
                this.selectedRows = [];
                this.form.resetFields();
            },
            deleteReset() {
                this.form.resetFields();
                this.dataSource = this.$utils.deepClone(this.menuDailogShops.suitRetail);
            },
            deleteSearch() {
                const mealList = this.$utils.deepClone(this.menuDailogShops.suitRetail);
                this.form.validateFields((err, values) => {
                    this.dataSource = mealList.filter(el => {
                        let {name, cateName, state, small, greater} = values;
                        let nameFilter = !name || el.dishName.indexOf(name) > -1
                        let cateNameFilter = !cateName || el.dishCateName.indexOf(cateName) > -1
                        let smallFilter = !small || el.price * 1 >= small;
                        let greaterFilter = !greater || el.price * 1 <= greater;
                        let stateFilter = state === undefined || el.state == state;
                        return nameFilter && cateNameFilter && smallFilter && greaterFilter && stateFilter;
                    });
                });
            },
            search(shop = {}) {
                if (shop.id) this.menuDailogShops = shop;
                this.form.validateFields((err, values) => {
                    if (err) return;
                    let shopId = this.menuDailogShops.id;
                    if (!shopId) return;
                    this.mealLoading = true;
                    this.$api.changeCode.getMenuList2new({
                        body: {
                            shopId: shopId,
                            ...values
                        }
                    }).then(res => {
                        this.dataSource = res;
                        this.tableSelectedRowKeys = shop.suitRetail.map(el => el.dishId);
                        this.mealLoading = false;
                    }).catch(err => {
                        this.mealLoading = false;
                    })
                })
                
            }
        }
    };
</script>

<style lang="scss">

</style>